import React from 'react';

const NotFound = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{
        background: `
          linear-gradient(45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
          linear-gradient(-45deg, rgba(255, 255, 255, 0.05) 25%, transparent 25%),
          linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%),
          linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.05) 75%),
          linear-gradient(to bottom, #1a1a1a 0%, #0d0d0d 90%)
        `,
        backgroundSize: '50px 50px',
        backgroundPosition: '0 0, 0 25px, 25px -25px, -25px 0px',
        boxShadow: 'inset 0 2px 12px rgba(12, 10, 10, 0.6)'
      }}
    >
      <div className="flex flex-col items-center space-y-6 text-center">
        <div className="relative">
          <div className="w-16 h-16 rounded-full bg-chess-green/20 flex items-center justify-center">
            <svg viewBox="0 0 448 512" fill="currentColor" className="w-8 h-8 text-chess-green" aria-hidden="true">
              <path d="M224 0c17.7 0 32 14.3 32 32l0 16 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 48 152 0c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400 80 400 3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40l152 0 0-48-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-16c0-17.7 14.3-32 32-32zM38.6 473.4L80 432l288 0 41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L54.6 512C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"/>
            </svg>
          </div>
        </div>
        <p style={{ color: '#9ca3af', fontSize: '0.95rem' }}>
          This route doesn't exist.
        </p>
        <a
          href="https://chessweb.site"
          style={{
            color: '#749555',
            fontSize: '0.85rem',
            textDecoration: 'none',
            fontWeight: 600,
          }}
        >
          Return to ChessWeb.site
        </a>
      </div>
    </div>
  );
};

export default NotFound;
